import { browserSupportsWebAuthn } from '@simplewebauthn/browser';
import { useState } from 'react';
import { useAuth } from '../auth.tsx';
import { Centered } from '../components/Layout.tsx';
import { passkeyErrorMessage, signInWithPasskey } from '../passkeys.ts';

export function LoginPage() {
  const { setUser } = useAuth();
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState<string | null>(null);
  const supported = browserSupportsWebAuthn();

  async function signIn() {
    setBusy(true);
    setError(null);
    try {
      setUser(await signInWithPasskey());
    } catch (e) {
      setError(passkeyErrorMessage(e));
    } finally {
      setBusy(false);
    }
  }

  return (
    <Centered>
      <section className="card stack">
        <button type="button" className="btn primary block" onClick={signIn} disabled={busy || !supported}>
          {busy ? 'Waiting for your passkey…' : 'Sign in with passkey'}
        </button>
        {error && (
          <p className="error" role="alert">
            {error}
          </p>
        )}
        {!supported && <p className="error">This browser doesn’t support passkeys.</p>}
        <p className="muted small">
          On a computer? Choose <strong>Use a phone or tablet</strong> and scan the QR code with the phone that has your
          passkey.
        </p>
        <p className="muted small">This is a private collection. Shared decks open from their own links, no sign-in needed.</p>
      </section>
    </Centered>
  );
}
